(() => {
  if (window.tmFestivalInitialized) return;
  window.tmFestivalInitialized = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-tmfv-copy]');
    if (!button) return;
    const area = button.closest('.tmfv, .tmfp');
    const status = area?.querySelector('[data-tmfv-status]');
    try {
      await navigator.clipboard.writeText('FESTIVAL');
      if (status) status.textContent = button.dataset.copied;
    } catch {
      if (status) status.textContent = button.dataset.failed;
    }
  });
  if (!customElements.get('tm-festival-popup')) {
    customElements.define('tm-festival-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.storageKey = 'tm-festival-welcome-nov2026';
        this.remember = () => { try { sessionStorage.setItem(this.storageKey, 'seen'); } catch {} };
        this.querySelectorAll('[data-tmfp-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => { this.remember(); this.returnFocus?.focus({preventScroll:true}); });
        this.querySelector('.tmfp__shop')?.addEventListener('click', () => this.remember());
        let seen = false;
        try { seen = sessionStorage.getItem(this.storageKey) === 'seen'; } catch {}
        if (seen && this.dataset.preview !== 'true') return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) || 2000);
      }
      open() {
        if (!this.isConnected || Date.now() >= Number(this.dataset.end)) return;
        if (document.querySelector('dialog[open]') || document.hidden) {
          this.timer = setTimeout(() => this.open(), 1500);
          return;
        }
        this.returnFocus = document.activeElement;
        this.dialog.showModal();
        this.remember();
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }
  document.querySelectorAll('[data-tmfv-expiry]').forEach(card => {
    if (Date.now() >= Number(card.dataset.tmfvExpiry)) card.hidden = true;
  });
})();
